export default __webpack_public_path__ + "static/media/simple-list-2.bfa3d11a.png";